<!-- 教师列表 -->
<template>
  <div>
    <div class="addExperiment-title">
      <span @click="goRouter('/college')"
        >学院管理&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <i>教师管理</i>
    </div>
    <div v-loading="loading" class="teacherBox">
      <!-- <header class="header">
      <span>{{ schoolInfo.schoolName }}>>教师列表</span>
      <router-link :to="`/alliance/school`" class="fr">
        <el-button size="small">返回</el-button>
      </router-link>
    </header> -->
      <div class="action boxlistTit">
        <!-- <Input
        search
        enter-button="搜索"
        @on-search="getTeachers"
        v-model="page.word"
        placeholder="用户名、学院名称、教师学名"
        class="fl"
        style="width:340px"
      />-->
        <el-input
          placeholder="教师名称"
          v-model="page.word"
          class="fl"
          style="width: 300px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getTeachers"
          ></el-button>
        </el-input>
        <input
          type="file"
          ref="uploadFile"
          @change="onChange"
          style="display: none"
        />
        <!-- <el-button class="fr" size="small" style="margin-left:10px;" @click="download">下载</el-button> -->
        <el-button
          type="primary"
          class="fr"
          style="margin-left: 10px"
          size="small"
          @click="goRouter('/college')"
          >返回</el-button
        >
        <el-button
          type="primary"
          class="fr"
          style="margin-left: 10px"
          size="small"
          @click="tolead"
          >导入教师</el-button
        >
        <router-link
          :to="`/alliance/teacher/edit?schoolId=${page.schoolId}`"
          class="fr"
        >
          <el-button type="primary" size="small">新建</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table :data="teacherList" style="width: 100%">
          <el-table-column
            prop="teacherId"
            label="ID"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="teacherName"
            label="教师名称"
          ></el-table-column>
          <el-table-column prop="collegeName" label="学院"></el-table-column>
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="remark" label="是否是管理员">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.role"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="setAdmin(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="是否禁用">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="disableTeacher(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="{ row }">
              <div>
                <!-- <router-link
                  :to="`/alliance/teacher/courses?schoolId=${page.schoolId}&teacherId=${row.teacherId}`"
                >
                  <el-button type="primary" size="small" class="ml10"
                    >授课管理</el-button
                  >
                </router-link> -->

                <!-- <el-button type="primary" size="small" class="ml10">编辑</el-button> -->
                <router-link
                  :to="`/alliance/teacher/edit?schoolId=${page.schoolId}&teacherId=${row.teacherId}`"
                >
                  <el-button type="primary" size="small"
                    >编辑</el-button
                  >
                </router-link>
                <el-button
                  type="primary"
                  size="small"
                  class="ml10"
                  @click="delCourse(row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="foot-pager"
          :page-size="10"
          :pager-count="11"
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page.pageIndex"
          @current-change="getTeachers"
        ></el-pagination>
      </div>
      <el-dialog
        title="导入教师信息"
        :visible.sync="dialogVisible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="400"
      >
        <el-form
          ref="formValidate"
          :model="form"
          label-width="100px"
          :rules="rule"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="导入模板下载">
                <el-button type="primary" size="mini" @click="download"
                  >下载</el-button
                >
              </el-form-item>
              <el-form-item label="文件上传" prop="files">
                <el-button size="mini" @click="onClick">文件上传</el-button>
                <p v-if="form.files" style="line-height: 30px; margin: 0">
                  {{ form.files.name }}
                </p>
                <p
                  style="
                    margin: 0px;
                    text-align: left;
                    font-size: 12px;
                    color: #8c8c8c;
                    line-height: 20px;
                  "
                >
                  <span>文件模板说明：sex(性别) 1:男 2:女";</span>
                  <!-- <br />education(学历) 1:高中及以下 2:大专 3:本科 4:硕士 5:博士; -->
                  <!-- <br />sex(性别) 1:男 2:女"; -->
                </p>
                <input
                  type="file"
                  ref="uploadFile"
                  @change="onChange"
                  style="display: none"
                />
              </el-form-item>
              <el-form-item label="高校" prop="schoolId">
                <el-select
                  disabled
                  v-model="form.schoolId"
                  @input="getSchoolChange(teacher.schoolId, 'reset')"
                >
                  <el-option
                    v-for="item in schoolData"
                    :key="item.schoolId"
                    :value="item.schoolId"
                    :label="item.schoolName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学院" prop="collegeId">
                <el-select v-model="form.collegeId">
                  <el-option
                    v-for="item in collegeData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="saveSubmit('formValidate')"
            size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import util from "@/assets/util/util.js";
let schoolById = JSON.parse(localStorage.getItem("USER")).schoolId;
export default {
  data() {
    return {
      rule: {
        collegeId: [
          {
            type: "number",
            required: true,
            message: "请选择学院",
            trigger: "onChange",
          },
        ],
        files: [
          {
            required: true,
            message: "文件不能为空",
            trigger: "onChange",
          },
        ],
      },
      collegeData: [],
      schoolData: [],
      form: {
        files: null,
        collegeId: null, // 学院id
        schoolId: Number(schoolById), // 高校id
        majorId: null, // 专业id
        gradeId: null, // 年级
        classId: null, // 班级
      },
      dialogVisible: false,
      total: 0,
      loading: false,
      schoolInfo: {},
      page: {
        showItem: 10,
        schoolId: schoolById,
        pageIndex: 1,
        type: 0,
        word: "",
      },
      columns: [
        {
          title: "ID",
          key: "teacherId",
        },
        {
          title: "教师名称",
          key: "teacherName",
        },
        {
          title: "学院",
          key: "collegeName",
        },
        {
          title: "用户ID",
          key: "userId",
        },
        {
          title: "备注",
          key: "remark",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      teacherList: [],
    };
  },
  methods: {
    //设为管理员
    setAdmin(row) {
      let params = {
        role: row.role ? 2 : 1,
        teacherId: row.teacherId,
      };
      this.$api.common.updateTeacherRole(params).then((res) => {
        if (res.errCode == 0) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    goRouter(path) {
      this.$router.push(path);
    },
    //禁用
    disableTeacher(row) {
      let params = {
        schoolId: schoolById,
        teacherId: row.teacherId,
        status: row.status ? 0 : 1,
      };
      this.$api.common.disableTeacher(params).then((res) => {
        if (res.errCode == 0) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 高校
    getSchoolChange(item, type) {
      // 获取学院列表
      const param = {
        showItem: 1000,
        schoolId: item,
        pageIndex: 1,
        word: "",
      };
      const paramSchool = {
        word: "",
      };
      // 高校select
      this.$api.allianceSchool.getSchoolList(paramSchool).then((res) => {
        if (res.errCode == 0) {
          this.schoolData = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
      // 学院select
      this.$api.allianceSchool.getCollegeList(param).then((res) => {
        if (res.errCode == 0) {
          this.collegeData = res.data.items;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 获取表单
    onChange() {
      this.form.files = this.$refs.uploadFile.files[0];

      // this.loading = true;
      // this.$api.allianceSchool.uploadTeacher(formData).then(item => {
      //   this.loading = false;
      //       if (item.errCode == 0) {
      //           this.getTeachers();
      //           this.getSchoolInfo();
      //       } else {
      //         this.$message.error(item.errMsg);
      //       }
      //     }).catch(res=>{
      //   this.loading = false;
      // });
    },
    onClick() {
      this.$refs.uploadFile.value = "";
      this.$refs.uploadFile.click();
    },
    // 模板下载
    download() {
      this.$api.allianceSchool.teacherMgrExcel().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        util.export(blob, "导入教师模板");
      });
    },
    // 导入教师
    tolead() {
      this.dialogVisible = true;
    },
    // 删除
    delCourse(item) {
      this.$confirm("您确认删除该教师吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          schoolId: schoolById,
          teacherId: item.teacherId,
        };
        this.$api.allianceSchool.delTeacher(param).then((res) => {
          if (res.errCode == 0) {
            this.page.pageIndex = 1;
            this.$message.success("删除成功");
            this.getTeachers();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 学院管理头部
    getSchoolInfo() {
      this.loading = true;
      this.$api.allianceSchool
        .getSchoolInfo(schoolById)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.schoolInfo = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    getTeachers() {
      this.loading = true;
      this.$api.allianceSchool
        .getTeacherList(this.page)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.teacherList = res.data.items;
            this.teacherList.forEach((item) => {
              item.role = item.role == 2 ? true : false;
              item.status = item.status == 0 ? true : false;
            });
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 教师导入保存
    saveSubmit(formName) {
      let formData = new FormData();
      let file = this.$refs.uploadFile.files[0];
      formData.append("files", file);
      formData.append("collegeId", this.form.collegeId);
      formData.append("schoolId", schoolById);
      const param = {
        collegeId: this.form.collegeId,
        schoolId: schoolById,
      };
      // formData.append("studentClassTO", JSON.stringify(this.form));
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.allianceSchool
            .uploadTeacher(param, formData)
            .then((item) => {
              if (item.errCode == 0) {
                this.dialogVisible = false;
                this.getTeachers();
                this.getSchoolInfo();
              } else {
                this.$message.error(item.errMsg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    this.getTeachers();
    this.getSchoolInfo();
    this.getSchoolChange(schoolById);
  },
};
</script>
<style lang='less' scoped>
.teacherBox {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .fr {
    float: right;
  }
  .fl {
    float: left;
  }

  .action {
    margin-bottom: 20px;
  }
  .ml10 {
    margin-left: 10px;
  }
  .ivu-message {
    z-index: 3000 !important;
  }
  .foot-pager {
    text-align: center;
  }
}
.addExperiment-title {
  margin-bottom: 16px;
  span,
  i {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    font-style: normal;
    opacity: 1;
  }
  span {
    color: #939393;
    cursor: pointer;
  }
}
</style>